import type * as core from '../../../../../../../core'

export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '{}': {
          insertion: {
            '{}': {
              inputs: {
                '{}': {
                  records: {
                    '[]': [
                      {
                        '{}': {
                          values: {
                            '{}': {
                              '!id': {
                                '@$': 'changeImpactId',
                              },
                              '!code': {
                                '@$': 'changeImpactCode',
                              },
                              '!name': {
                                '@$': 'changeImpactName',
                              },
                              '!type': {
                                '@$': 'changeImpactType',
                              },
                              '!descr': {
                                '@$': 'changeImpactDescription',
                              },
                              '!topic': {
                                '@$': 'changeImpactTopic',
                              },
                              '!key_benefit': {
                                '@$': 'changeImpactKeyBenefit',
                              },
                              '!future_state': {
                                '@$': 'changeImpactFutureState',
                              },
                              '!current_state': {
                                '@$': 'changeImpactCurrentState',
                              },
                              '!other_comments': {
                                '@$': 'changeImpactOtherComments',
                              },
                              '!area_of_concern': {
                                '@$': 'changeImpactAreaOfConcern',
                              },
                              '!workstream': {
                                '@$': 'changeImpactWorkstream',
                              },
                              '!degree_of_change': {
                                '@$': 'changeImpactDegreeOfChange',
                              },
                              '!validation_status': {
                                '@$': 'changeImpactValidationStatus',
                              },
                              '!target_go_live_date': {
                                '@$': 'changeImpactTargetGoLiveDate',
                              },
                              '!communications_notes': {
                                '@$': 'changeImpactCommunicationsNotes',
                              },
                              '!communications_needed': {
                                '@$': 'changeImpactCommunicationsNeeded',
                              },
                              '!training_implications': {
                                '@$': 'changeImpactTrainingImplications',
                              },
                              '!training_implications_notes': {
                                '@$': 'changeImpactTrainingImplicationsNotes',
                              },
                              '!anticipated_response_of_change': {
                                '@$': 'changeImpactAnticipatedResponseOfChange',
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              modelId: 'ent:!change_impacts:!change_impact',
            },
          },
        },
      },
      operation: 'dms.mutate',
    },
  },
}
